<h2 mat-dialog-title class="perse-dialog-title">Download Already Initiated</h2>

<mat-dialog-content>
  <div class="info-banner">
    <mat-icon class="info-icon">info</mat-icon>
    <div class="info-text">
      <p>You have already initiated a download for this meter.</p>
      @if (createdAt) {
        <p class="created-date">
          Initiated on: <strong>{{ createdAt | date:'medium' }}</strong>
        </p>
      }
    </div>
  </div>

  <div class="options-description">
    <p>Would you like to download the same data or request a fresh download?</p>
    <ul>
      <li><strong>Download Same</strong> — use the previously generated data file</li>
      <li><strong>Download Latest</strong> — request a new data file with the most recent data</li>
    </ul>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-stroked-button color="primary" (click)="onDownloadSame()">
    <mat-icon>download</mat-icon>
    Download Same
  </button>
  <button mat-flat-button color="primary" (click)="onDownloadLatest()">
    <mat-icon>refresh</mat-icon>
    Download Latest
  </button>
</mat-dialog-actions>
